import { IS_API_LOADER, IS_USER_MANAGEMENT_LOADER } from "../action/loaderActions";


const initialState = {
    isUsermanagementLoader: false,
    isApiLoader: false,
}

const loaderReducer = (state = initialState, action) => {
    switch (action?.type) {
        case IS_USER_MANAGEMENT_LOADER:
            return{
                ...state,
                isUsermanagementLoader: action.payload.isUsermanagementLoader,
            }  
        case IS_API_LOADER:
            return{
                ...initialState,
                isApiLoader: action.payload.isApiLoader,
            }  
        default:
            return state;
    }
}

export default loaderReducer;